import { Injectable } from '@angular/core';
import { ClientAuthenticationTokenService, ClientToken } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomClientAuthenticationTokenService extends ClientAuthenticationTokenService {
  loadClientAuthenticationToken(): Observable<ClientToken> {
    const url = '/api/clienttoken';
    return this.http.get<ClientToken>(url);
  }
}
